import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getSendbirdToken({ payload: { onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.token });

    yield put(actions.getSendbirdTokenDone(data));
    onSuccess &&  onSuccess();
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSendbirdTokenFailed,
      endpoint: api.sendbird.token
    });
  }
}

export const getSendbirdTokenSaga = takeEvery(types.GET_SENDBIRD_TOKEN_REQUEST, getSendbirdToken);